/// <amd-module name="SuiteCommerce.PagePrinter.ExtQRCode.Utils"/>
define("SuiteCommerce.PagePrinter.ExtQRCode.Utils", ["require", "exports", "SuiteCommerce.PagePrinter.ExtQRCode.Polynomial"], function (require, exports, Polynomial_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.QRMode = 1 << 2;
    exports.PAD0 = 0xec;
    exports.PAD1 = 0x11;
    var QRCorrectionLevel;
    (function (QRCorrectionLevel) {
        QRCorrectionLevel[QRCorrectionLevel["L"] = 1] = "L";
        QRCorrectionLevel[QRCorrectionLevel["M"] = 0] = "M";
        QRCorrectionLevel[QRCorrectionLevel["Q"] = 3] = "Q";
        QRCorrectionLevel[QRCorrectionLevel["H"] = 2] = "H";
    })(QRCorrectionLevel = exports.QRCorrectionLevel || (exports.QRCorrectionLevel = {}));
    var QRMaskPattern;
    (function (QRMaskPattern) {
        QRMaskPattern[QRMaskPattern["PATTERN000"] = 0] = "PATTERN000";
        QRMaskPattern[QRMaskPattern["PATTERN001"] = 1] = "PATTERN001";
        QRMaskPattern[QRMaskPattern["PATTERN010"] = 2] = "PATTERN010";
        QRMaskPattern[QRMaskPattern["PATTERN011"] = 3] = "PATTERN011";
        QRMaskPattern[QRMaskPattern["PATTERN100"] = 4] = "PATTERN100";
        QRMaskPattern[QRMaskPattern["PATTERN101"] = 5] = "PATTERN101";
        QRMaskPattern[QRMaskPattern["PATTERN110"] = 6] = "PATTERN110";
        QRMaskPattern[QRMaskPattern["PATTERN111"] = 7] = "PATTERN111";
    })(QRMaskPattern = exports.QRMaskPattern || (exports.QRMaskPattern = {}));
    exports.QRCodeLimitLength = [
        [17, 14, 11, 7],
        [32, 26, 20, 14],
        [53, 42, 32, 24],
        [78, 62, 46, 34],
        [106, 84, 60, 44],
        [134, 106, 74, 58],
        [154, 122, 86, 64],
        [192, 152, 108, 84],
        [230, 180, 130, 98],
        [271, 213, 151, 119],
        [321, 251, 177, 137],
        [367, 287, 203, 155],
        [425, 331, 241, 177],
        [458, 362, 258, 194],
        [520, 412, 292, 220],
        [586, 450, 322, 250],
        [644, 504, 364, 280],
        [718, 560, 394, 310],
        [792, 624, 442, 338],
        [858, 666, 482, 382],
        [929, 711, 509, 403],
        [1003, 779, 565, 439],
        [1091, 857, 611, 461],
        [1171, 911, 661, 511],
        [1273, 997, 715, 535],
        [1367, 1059, 751, 593],
        [1465, 1125, 805, 625],
        [1528, 1190, 868, 658],
        [1628, 1264, 908, 698],
        [1732, 1370, 982, 742],
        [1840, 1452, 1030, 790],
        [1952, 1538, 1112, 842],
        [2068, 1628, 1168, 898],
        [2188, 1722, 1228, 958],
        [2303, 1809, 1283, 983],
        [2431, 1911, 1351, 1051],
        [2563, 1989, 1423, 1093],
        [2699, 2099, 1499, 1139],
        [2809, 2213, 1579, 1219],
        [2953, 2331, 1663, 1273],
    ];
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.getBCHTypeInfo = function (mask) {
            var digit = mask << 10;
            while (this.getBCHDigit(digit) - this.getBCHDigit(this.G15) >= 0) {
                digit ^=
                    this.G15 << (this.getBCHDigit(digit) - this.getBCHDigit(this.G15));
            }
            return ((mask << 10) | digit) ^ this.G15_MASK;
        };
        Utils.getBCHIdentifier = function (data) {
            var digit = data << 12;
            while (this.getBCHDigit(digit) - this.getBCHDigit(this.G18) >= 0) {
                digit ^=
                    this.G18 << (this.getBCHDigit(digit) - this.getBCHDigit(this.G18));
            }
            return (data << 12) | digit;
        };
        Utils.getBCHDigit = function (data) {
            var digit = 0;
            while (data != 0) {
                digit++;
                data >>>= 1;
            }
            return digit;
        };
        Utils.getPatternPosition = function (typeNumber) {
            return this.PATTERN_POSITION_TABLE[typeNumber - 1];
        };
        Utils.getMask = function (maskPattern, i, j) {
            switch (maskPattern) {
                case QRMaskPattern.PATTERN000:
                    return (i + j) % 2 == 0;
                case QRMaskPattern.PATTERN001:
                    return i % 2 == 0;
                case QRMaskPattern.PATTERN010:
                    return j % 3 == 0;
                case QRMaskPattern.PATTERN011:
                    return (i + j) % 3 == 0;
                case QRMaskPattern.PATTERN100:
                    return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
                case QRMaskPattern.PATTERN101:
                    return ((i * j) % 2) + ((i * j) % 3) == 0;
                case QRMaskPattern.PATTERN110:
                    return (((i * j) % 2) + ((i * j) % 3)) % 2 == 0;
                case QRMaskPattern.PATTERN111:
                    return (((i * j) % 3) + ((i + j) % 2)) % 2 == 0;
                default:
                    throw new Error('Bad maskPattern');
            }
        };
        Utils.getLengthInBits = function (type) {
            if (1 <= type && type < 10) {
                return 8;
            }
            else if (type < 41) {
                return 16;
            }
        };
        Utils.getErrorCorrectPolynomial = function (errorCorrectLength, qrCode) {
            var polynomial = new Polynomial_1.Polynomial([1], 0);
            for (var i = 0; i < errorCorrectLength; i++) {
                polynomial = polynomial.multiply(new Polynomial_1.Polynomial([1, qrCode.getExponential(i)], 0), qrCode);
            }
            return polynomial;
        };
        Utils.getLostPoint = function (qrCode) {
            var moduleCount = qrCode.getModuleQuantity();
            var lostPoint = 0;
            for (var row_1 = 0; row_1 < moduleCount; row_1++) {
                for (var col_1 = 0; col_1 < moduleCount; col_1++) {
                    var sameCount = 0;
                    var dark = qrCode.isDarkBlock(row_1, col_1);
                    for (var r = -1; r <= 1; r++) {
                        if (row_1 + r < 0 || moduleCount <= row_1 + r) {
                            continue;
                        }
                        for (var c = -1; c <= 1; c++) {
                            if (col_1 + c < 0 || moduleCount <= col_1 + c) {
                                continue;
                            }
                            if (r == 0 && c == 0) {
                                continue;
                            }
                            if (dark == qrCode.isDarkBlock(row_1 + r, col_1 + c)) {
                                sameCount++;
                            }
                        }
                    }
                    if (sameCount > 5) {
                        lostPoint += 3 + sameCount - 5;
                    }
                }
            }
            for (var row_2 = 0; row_2 < moduleCount - 1; row_2++) {
                for (var col_2 = 0; col_2 < moduleCount - 1; col_2++) {
                    var count = 0;
                    if (qrCode.isDarkBlock(row_2, col_2))
                        count++;
                    if (qrCode.isDarkBlock(row_2 + 1, col_2))
                        count++;
                    if (qrCode.isDarkBlock(row_2, col_2 + 1))
                        count++;
                    if (qrCode.isDarkBlock(row_2 + 1, col_2 + 1))
                        count++;
                    if (count == 0 || count == 4) {
                        lostPoint += 3;
                    }
                }
            }
            for (var row_3 = 0; row_3 < moduleCount; row_3++) {
                for (var col_3 = 0; col_3 < moduleCount - 6; col_3++) {
                    if (qrCode.isDarkBlock(row_3, col_3) &&
                        !qrCode.isDarkBlock(row_3, col_3 + 1) &&
                        qrCode.isDarkBlock(row_3, col_3 + 2) &&
                        qrCode.isDarkBlock(row_3, col_3 + 3) &&
                        qrCode.isDarkBlock(row_3, col_3 + 4) &&
                        !qrCode.isDarkBlock(row_3, col_3 + 5) &&
                        qrCode.isDarkBlock(row_3, col_3 + 6)) {
                        lostPoint += 40;
                    }
                }
            }
            for (var col_4 = 0; col_4 < moduleCount; col_4++) {
                for (var row_4 = 0; row_4 < moduleCount - 6; row_4++) {
                    if (qrCode.isDarkBlock(row_4, col_4) &&
                        !qrCode.isDarkBlock(row_4 + 1, col_4) &&
                        qrCode.isDarkBlock(row_4 + 2, col_4) &&
                        qrCode.isDarkBlock(row_4 + 3, col_4) &&
                        qrCode.isDarkBlock(row_4 + 4, col_4) &&
                        !qrCode.isDarkBlock(row_4 + 5, col_4) &&
                        qrCode.isDarkBlock(row_4 + 6, col_4)) {
                        lostPoint += 40;
                    }
                }
            }
            var darkCount = 0;
            for (var col = 0; col < moduleCount; col++) {
                for (var row = 0; row < moduleCount; row++) {
                    if (qrCode.isDarkBlock(row, col)) {
                        darkCount++;
                    }
                }
            }
            var ratio = Math.abs((100 * darkCount) / moduleCount / moduleCount - 50) / 5;
            lostPoint += ratio * 10;
            return lostPoint;
        };
        Utils.PATTERN_POSITION_TABLE = [
            [],
            [6, 18],
            [6, 22],
            [6, 26],
            [6, 30],
            [6, 34],
            [6, 22, 38],
            [6, 24, 42],
            [6, 26, 46],
            [6, 28, 50],
            [6, 30, 54],
            [6, 32, 58],
            [6, 34, 62],
            [6, 26, 46, 66],
            [6, 26, 48, 70],
            [6, 26, 50, 74],
            [6, 30, 54, 78],
            [6, 30, 56, 82],
            [6, 30, 58, 86],
            [6, 34, 62, 90],
            [6, 28, 50, 72, 94],
            [6, 26, 50, 74, 98],
            [6, 30, 54, 78, 102],
            [6, 28, 54, 80, 106],
            [6, 32, 58, 84, 110],
            [6, 30, 58, 86, 114],
            [6, 34, 62, 90, 118],
            [6, 26, 50, 74, 98, 122],
            [6, 30, 54, 78, 102, 126],
            [6, 26, 52, 78, 104, 130],
            [6, 30, 56, 82, 108, 134],
            [6, 34, 60, 86, 112, 138],
            [6, 30, 58, 86, 114, 142],
            [6, 34, 62, 90, 118, 146],
            [6, 30, 54, 78, 102, 126, 150],
            [6, 24, 50, 76, 102, 128, 154],
            [6, 28, 54, 80, 106, 132, 158],
            [6, 32, 58, 84, 110, 136, 162],
            [6, 26, 54, 82, 110, 138, 166],
            [6, 30, 58, 86, 114, 142, 170],
        ];
        Utils.G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
        Utils.G18 = (1 << 12) |
            (1 << 11) |
            (1 << 10) |
            (1 << 9) |
            (1 << 8) |
            (1 << 5) |
            (1 << 2) |
            (1 << 0);
        Utils.G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);
        return Utils;
    }());
    exports.Utils = Utils;
});
